export default "__VITE_ASSET__Ai911_R4__"